import { MAX_RECENT_SEARCH_TERMS, RECENT_TERMS_STORAGE_KEY } from '@shared/constants/global-search.constants';
import { NuggetSearchResult, TopicSearchResult } from '@spe-content-store/interfaces';
import { HighlightPart, SearchResult } from '@shared/models/search-result.model';

export const readRecentTerms = (): string[] => {
    try {
        const stored: unknown = JSON.parse(localStorage.getItem(RECENT_TERMS_STORAGE_KEY) ?? '[]');
        return Array.isArray(stored)
            ? stored.filter((term): term is string => typeof term === 'string').slice(0, MAX_RECENT_SEARCH_TERMS)
            : [];
    } catch {
        return [];
    }
};

export const writeRecentTerms = (terms: string[]): void => {
    try {
        localStorage.setItem(RECENT_TERMS_STORAGE_KEY, JSON.stringify(terms));
    } catch {
        // Storage may be unavailable (private mode, quota); recent terms are a convenience only.
    }
};

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const splitOnTerm = (text: string, term: string): HighlightPart[] => {
    if (!term) {
        return [{ text, match: false }];
    }

    const lowerTerm = term.toLocaleLowerCase();
    return text
        .split(new RegExp(`(${escapeRegExp(term)})`, 'ig'))
        .filter(part => part.length > 0)
        .map(part => ({ text: part, match: part.toLocaleLowerCase() === lowerTerm }));
};

export const toTopicResult = (hit: TopicSearchResult): SearchResult => ({
    id: `sequence:${hit.id}`,
    kind: 'sequence',
    title: hit.name,
    subtitle: hit.description ?? null,
    routerLink: `/sequences/${hit.id}`
});

/** Opens the topic that contains the nugget. */
export const toNuggetResult = (hit: NuggetSearchResult): SearchResult => ({
    id: `nugget:${hit.id}`,
    kind: 'nugget',
    title: hit.name,
    subtitle: hit.description ?? null,
    routerLink: `/sequences/${hit.topicId}`
});

export const compareResultsByTitle = (left: SearchResult, right: SearchResult): number =>
    left.title.localeCompare(right.title, undefined, { sensitivity: 'base' });
